// extracted by mini-css-extract-plugin
export var postGrid = "B_bQ";
export var wpPageLayout = "B_bP";
export var wpPageRelatedGrid = "B_bR";
export var wpPageRoot = "B_bN";